export default __webpack_public_path__ + "static/media/ai-image-generator-screenshot-06.2239fdda.png";